import React, { useState } from "react";
import "./MaintenanceDoor.css";
import Navbar from "../../Common/Navbar";

function MaintenanceDoor() {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [message, setMessage] = useState("System is fully operational");

  const toggleMaintenance = () => {
    const nextState = !isMaintenance;
    setIsMaintenance(nextState);

    setMessage(
      nextState
        ? "⚠️ System is under maintenance. Some features may be unavailable."
        : "✅ System is fully operational"
    );
  };

  return (
    <div>
      <Navbar />

      <div className="maintenance-page">
        <div className="maintenance-container">
          <div className="maintenance-header">
            <span className="maintenance-badge">System Control</span>
            <h1>Maintenance Door</h1>
            <p>Control system maintenance mode & server availability</p>
          </div>

          <div className="maintenance-layout">
            <div className={`maintenance-card ${isMaintenance ? "danger" : "success"}`}>
              <div className="maintenance-card-top">
                <div>
                  <span className="maintenance-small-title">Current Status</span>
                  <h2>Status</h2>
                </div>

                <div className={`maintenance-icon ${isMaintenance ? "danger" : "success"}`}>
                  {isMaintenance ? "🚧" : "✅"}
                </div>
              </div>

              <p>{message}</p>

              <div className="status-indicator">
                <span className={`dot ${isMaintenance ? "red" : "green"}`}></span>
                {isMaintenance ? "Maintenance Mode ON" : "System Active"}
              </div>

              <button className="toggle-btn" onClick={toggleMaintenance}>
                {isMaintenance ? "Disable Maintenance" : "Enable Maintenance"}
              </button>
            </div>

            <div className="maintenance-logs">
              <div className="logs-top">
                <span>Live Logs</span>
                <h2>Recent Activity</h2>
              </div>

              <ul>
                <li>✔ System started successfully</li>
                <li>✔ Database connection stable</li>
                <li>⚙ Last update deployed 2 days ago</li>
              </ul>
            </div>
          </div>

          <div className="maintenance-grid">
            <div className="info-box">
              <div className="info-icon">🚧</div>
              <h3>Maintenance Mode</h3>
              <p>
                When enabled, users will see a maintenance page and access will be limited.
              </p>
            </div>

            <div className="info-box">
              <div className="info-icon">⏰</div>
              <h3>Scheduling</h3>
              <p>
                You can schedule downtime for updates, fixes or deployment changes.
              </p>
            </div>

            <div className="info-box">
              <div className="info-icon">🔐</div>
              <h3>Safe Mode</h3>
              <p>
                All data remains safe. Only frontend access is temporarily disabled.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MaintenanceDoor;